import { camelCase } from 'change-case'
import dayjs from 'dayjs'

export default function convertPropNames<T>(obj: any): T {
  if (obj instanceof Array) {
    return obj.map((item) => convertPropNames(item)) as any
  }
  if (typeof obj === 'object' && obj && !dayjs.isDayjs(obj)) {
    const result = {} as any
    Object.keys(obj).forEach((key) => {
      const propName = camelCase(key) as string
      result[propName] = convertPropNames(obj[key])
    })
    return result as T
  }

  return obj as T
}
